// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

import angular from "angular"
import { Item } from "../models/item"
import _ from "underscore"
class SavedItemsService {
   $rootScope: any
   availability: any
   bucket: any
   config: any
   cookies: any
   dialogService: any
   idleMessageDisplayed: any
   items: any
   store: any
   translationService: any
   cloudStorage: any
   cloudStoreFn: any
   hooksService: HooksService
   retrieving: boolean
   filename: string
   fileId: any
   fire: any
   alerts: AlertService
   firstSave: boolean
   user: { authenticated: boolean }
   loginEnabled: boolean
   constructor(store: any, availability: any, cookies: any, config: any, dialogService: any, $rootScope: any, translationService: any, cloudStorage: any, hooksService: HooksService, alertService: AlertService) {
      this.signInHandler = this.signInHandler.bind(this)
      this.signOutHandler = this.signOutHandler.bind(this)
      this.getSavedItems = this.getSavedItems.bind(this)
      this.hadSavedItems = this.hadSavedItems.bind(this)
      this.save = this.save.bind(this)
      this.add = this.add.bind(this)
      this.remove = this.remove.bind(this)
      this.clear = this.clear.bind(this)
      this.showIdleMessage = this.showIdleMessage.bind(this)
      this.displayDialog = this.displayDialog.bind(this)
      this.contains = this.contains.bind(this)
      this.store = store
      this.availability = availability
      this.cookies = cookies
      this.config = config
      this.dialogService = dialogService
      this.$rootScope = $rootScope
      this.translationService = translationService
      this.bucket = this.store.bucket('savedItems')
      this.retrieving = false
      this.cloudStorage = cloudStorage
      this.hooksService = hooksService
      this.filename = "savedSummonItems.json"
      this.fileId = null
      this.alerts = alertService
      this.firstSave = true
      this.user = { authenticated : false}
      const {
         savedItemsTimeout
      } = this.config.data.savedSearchAndItems
      this.loginEnabled = this.config.data.savedSearchAndItems.itemsEnabled && this.config.data.savedSearchAndItems.providers?.length
      if ((this.bucket.age() > (savedItemsTimeout*60)) || !this.hadSavedItems()) { this.bucket.clear() } // savedItemsTimeout minutes or if hasSavedItems cookie is removed (on browser exit)
      this.items = this.bucket.get('items') || []
      // get availability for docs in saved items folder
      if (this.items.length) { this.availability.getRTA(this.items, true) }

      // set up hooks
      hooksService.setHooks(this, 'SavedItemsService', ['getSavedItems'], true)

      // pull in saved items when user is signed in
      this.cloudStorage.on('signIn', 'savedItemsService', this.signInHandler)

      // clear saved items when user signs out
      this.cloudStorage.on('signOut', 'savedItemsService', this.signOutHandler)
   }

   reset() {
      this.fileId = null
      this.items.splice(0,this.items.length)
      this.items.push(...(this.bucket.get('items') || []))
   }

   signInHandler() {
      if (this.retrieving) { return }
      this.user.authenticated = true
      // Only enable direct cloud writes AFTER the initial restore/merge has completed,
      // so an item saved during the auth→cloud transition is merged before further saves.
      const result: any = this.getSavedItems()
      if (result && typeof result.then === 'function') {
         // Guard: only enable cloud writes if the user is still authenticated when the
         // restore resolves.  Without this, a logout that completes while getSavedItems()
         // is in-flight would be overwritten by this stale callback.
         result.then(() => { if (this.user.authenticated) { this.cloudStoreFn = this.cloudStoreList } })
      } else {
         this.cloudStoreFn = this.cloudStoreList
      }
   }

   signOutHandler() {
      this.reset()
      this.user.authenticated = false
      // reset cloud store function
      this.cloudStoreFn = null
   }

   hadSavedItems() {
      const had = !!this.cookies.getObject('hasSavedItems')
      this.cookies.putObject('hasSavedItems', 1)
      return had
   }

   save(removedItem=null) {
      // store to cloud if capability exists
      if (this.cloudStoreFn) {
         return this.cloudStoreFn(this.items, removedItem)
      } else {
         // save to session
         this.bucket.set('items', this.items)
         const saveMsg =  this.translationService.translations.ITEM_HAS_BEEN_SAVED
         this.alerts.pulseAlert('savedItemSuccess', saveMsg)
      }
   }

   cloudStoreList(itemsList: any, removedItem=null) {
      return this.cloudStorage.writeToFile(itemsList, this.fileId, 'items', removedItem).then((response: any) => {
         // errors are handled in controller or directive
         // if the cloud service wants to update this with a new list (userService does this to keep track of IDs)
         // we can return this newSavedItemsList key with an array, otherwise it uses the internal searchList
         if (response.newSavedItemsList) {
            this.items.splice(0,this.items.length)
            this.items.push(...response.newSavedItemsList)
         }
      })
   }

   add(doc: any, displayDialogCallback: any, $event: any) {
      if(this.firstSave) {
         this.firstSave = false
         if(!this.user.authenticated && this.loginEnabled && displayDialogCallback) {
            displayDialogCallback('savedItem', $event)
         }
      }
      const item : Item = this.formatItemForSave(doc)
      if (this.contains(item)) { return } // this prevents duplicate bookmarks
      if (this.items.length >= 50) {
         return alert("The maximum number of saved results is 50.")
      }
      this.items.push(item)
      const saveResult: any = this.save()
      const isCloudSave = !!(saveResult && typeof saveResult.then === 'function')
      const docAvailability = this.availability.getAvailability(item.availability_id)
      const rtaLoaded = !!(docAvailability.availabilities || docAvailability.error)

      if (!isCloudSave) {
         // Session (offline) save: the item is durable immediately, so mark it saved now.
         return rtaLoaded
            ? this.availability.saveRTA(item)
            : this.availability.getSingleDocRTA(item, true)
      }

      // Cloud save: the outcome is unknown until the POST resolves. Fetch the item's RTA
      // with saved=false so a rolled-back item never lingers as "saved" — the previous
      // optimistic saved=true could win a race against handleSaveFailure's unsaveRTA when
      // the availability entry did not exist yet (unsaveRTA no-ops on a missing entry, then
      // the in-flight RTA request writes saved=true). Flip to saved=true only once the save
      // actually succeeds (after the RTA fetch settles, if one is in flight).
      const rtaPromise: any = rtaLoaded ? null : this.availability.getSingleDocRTA(item, false)
      saveResult.then(
         () => {
            if (rtaPromise && typeof rtaPromise.then === 'function') {
               rtaPromise.then(() => this.availability.saveRTA(item))
            } else {
               this.availability.saveRTA(item)
            }
         },
         (err: any) => this.handleSaveFailure(item, err)
      )
      return rtaPromise
   }

   handleSaveFailure(item: any, err: any) {
      // Roll back whenever the server definitively did not persist the item — both
      // validation (4xx) and server (5xx) errors. The failed POST is never retried, so
      // the item is not on the server; keeping it would show a phantom count that
      // disappears on the next login. A pure network error (status -1 / unknown) is left
      // in place, since the request may not have reached the server and will reconcile on
      // the next getSavedItems restore.
      const status = err && typeof err.status === 'number' ? err.status : null
      const serverRejected = status !== null && status >= 400
      if (serverRejected) {
         const idx = _.indexOf(this.items, item)
         if (idx > -1) { this.items.splice(idx, 1) }
         this.availability.unsaveRTA(item)
         this.bucket.set('items', this.items)
      }
      // Surface the failure either way so the user is never left with a silent error.
      const error = err instanceof Error
         ? err
         : new Error((err && err.message) || this.translationService.translations.CLOUD_STORAGE_API_ERROR)
      this.fire('getSavedItems', error)
   }

   remove(item: any) {
      const result = _.filter(this.items, (i: any) => i.bookmark === item.bookmark)  // extract proper item according to bookmark value
      const removed = result[0]
      const idx = _.indexOf(this.items, removed)
      // Guard against splice(-1, 1): if the item isn't in the list, do NOT remove the last
      // element by accident. Nothing to delete, so nothing to persist.
      if (idx === -1) { return }
      this.items.splice(idx, 1)
      this.availability.unsaveRTA(removed)
      const saveResult: any = this.save(removed)
      // Cloud saves return a promise; a failed delete write must not be swallowed (it would
      // show the item as deleted while it is still on the server, so it reappears on the next
      // refresh/login). Roll the optimistic delete back and surface the error, mirroring add().
      // The session (non-promise) save path is durable immediately, so it needs no handling.
      if (saveResult && typeof saveResult.then === 'function') {
         saveResult.then(null, (err: any) => this.handleRemoveFailure(removed, idx, err))
      }
   }

   handleRemoveFailure(item: any, idx: number, err: any) {
      // The delete write did not persist, so the item is still on the server. Restore it in
      // the UI at its original position, re-mark its availability as saved, re-sync the bucket,
      // and surface the error so the deletion is not silently lost (it would otherwise reappear
      // on the next login/refresh with no explanation).
      if (!this.contains(item)) {
         const insertAt = (idx >= 0 && idx <= this.items.length) ? idx : this.items.length
         this.items.splice(insertAt, 0, item)
         this.availability.saveRTA(item)
         this.bucket.set('items', this.items)
      }
      const error = err instanceof Error
         ? err
         : new Error((err && err.message) || this.translationService.translations.CLOUD_STORAGE_API_ERROR)
      this.fire('getSavedItems', error)
   }

   clear() {
      _.each(this.items, (item: any) => this.availability.unsaveRTA(item))
      this.items.length = 0
      return this.bucket.clear()
   }

   showIdleMessage() {
      if (this.items.length && !this.idleMessageDisplayed) {
         this.idleMessageDisplayed = true
         const scope = this.$rootScope.$new(true)
         scope.i18n = this.translationService
         scope.closeCallback = () => {
            return this.idleMessageDisplayed = false
         }
         scope.timeToClear = (new Date(Date.now() + 300000)).toLocaleTimeString()
         scope.message = "Your saved items will be cleared at %{timeToClear}. Close this dialog before the specified time to retain your saved items."
         scope.params =
        {timeToClear: (new Date(Date.now() + 300000)).toLocaleTimeString()}
         return this.displayDialog("alert", scope)
      }
   }

   displayDialog(type: any, scope = this.$rootScope.$new(true)) {
      return this.dialogService.displayDialog(type, scope)
   }

   contains(item: any) {
      if (!item) { return false }
      // TODO: optimize with lookup table (by bookmark) if this gets too slow
      return _(this.items).some((other: any) => {
         if (item.bookmark && other.bookmark) {
            return item.bookmark === other.bookmark
         }
         return !!(item.id && item.id === other.id)
      })
   }

   getSavedItems() {
      this.retrieving = true

      const getFileContents = () => {
         return this.cloudStorage.getFileContents(this.fileId, 'items')
            .then((response: any) => {
               this.retrieving = false
               const cloudItems = _.isEmpty(response) ? [] : response
               const sessionItems = this.items.splice(0, this.items.length)
               const seenBookmarks = new Set<string>()
               const mergedCloudItems = cloudItems.filter((i: any) => {
                  if (!i.bookmark) { return true }
                  if (seenBookmarks.has(i.bookmark)) { return false }
                  seenBookmarks.add(i.bookmark)
                  return true
               })
               const uniqueSessionItems = sessionItems.filter((i: any) => !i.bookmark || !seenBookmarks.has(i.bookmark))
               this.items.push(...uniqueSessionItems, ...mergedCloudItems)
               const cloudHadDuplicates = mergedCloudItems.length < cloudItems.length
               if (uniqueSessionItems.length > 0 || cloudHadDuplicates) {
                  // Snapshot the bookmarks and IDs that are being written now.  Any item
                  // saved during the in-flight HTTP round-trip will be appended to this.items
                  // (via add() → save() → bucket.set()) AFTER this snapshot was taken, so
                  // it will NOT be in these sets and will survive the post-write clear.
                  const mergedBookmarks = new Set(this.items.map((i: any) => i.bookmark).filter(Boolean))
                  const mergedIds = new Set(this.items.map((i: any) => i.id).filter(Boolean))
                  return this.cloudStorage.writeToFile(this.items, this.fileId, 'items').then((response: any) => {
                     // Only clear session entries that were included in the write above.
                     // Items saved during the in-flight write remain in the bucket so they
                     // can be merged on the next getSavedItems call (avoids silent data loss).
                     // For bookmark-less items, fall back to ID de-dup so that items already
                     // written are not kept in the bucket and re-merged on the next login.
                     const sessionItems: any[] = this.bucket.get('items') || []
                     const remaining = sessionItems.filter((i: any) => {
                        if (i.bookmark) return !mergedBookmarks.has(i.bookmark)
                        if (i.id)       return !mergedIds.has(i.id)
                        return false // no bookmark, no id: cannot identify; treat as already written
                     })
                     if (remaining.length === 0) {
                        return this.bucket.clear()
                     } else {
                        return this.bucket.set('items', remaining)
                     }
                  }).catch((err: any) => {
                     // The writeback of merged session items failed (e.g. one item was
                     // rejected by the backend). The GET already succeeded, so the merged
                     // in-memory list — including the cloud items — is still valid; do NOT
                     // reset() (which would drop the freshly-fetched cloud items from the UI
                     // and null the fileId). Surface the error instead; the leftover session
                     // items stay in the bucket and are retried on the next getSavedItems.
                     // Normalize non-Error rejections into an Error (preserving status) so
                     // downstream hook handlers see a consistent shape.
                     const error: any = err instanceof Error
                        ? err
                        : new Error((err && err.message) || this.translationService.translations.CLOUD_STORAGE_API_ERROR)
                     if (err && err.status != null && error.status == null) { error.status = err.status }
                     this.fire('getSavedItems', error)
                  })
               }
            }).catch((err: any) => {
               this.reset()
               // in order for registered hooks to process the error, fire 'getSavedItems' with parsed error
               this.fire('getSavedItems', err)
               return this.retrieving = false
            })
      }

      if (this.fileId) {
      // get saved items if we already have file id
         return getFileContents()
      } else {
      // get file id (from list or create file) then get contents
         return this.cloudStorage.getFileId(this.filename).then((fileId: any) => {
            this.fileId = fileId
            return getFileContents()
         }).catch((err: any) => {
            this.reset()
            this.fire('getSavedItems', err)
            return this.retrieving = false
         })
      }
   }

   formatItemForSave(doc: any) : Item {
      return {
         $$hashKey: doc.$$hashKey,
         _hasAltmetric: doc._hasAltmetric,
         authors: doc.authors,
         availability_id: doc.availability_id,
         bookmark: doc.bookmark,
         content_type: doc.content_type,
         course_reserves: doc.course_reserves,
         deweys: doc.deweys,
         display_thumbnail: doc.display_thumbnail,
         editions: doc.editions,
         editors: doc.editors,
         full_title: doc.full_title,
         hasDetailPage: doc.hasDetailPage,
         has_fulltext: doc.has_fulltext,
         id: doc.id,
         index: doc.index,
         is_open_access: doc.is_open_access,
         is_peer_reviewed: doc.is_peer_reviewed,  
         issues: doc.issues,
         journalCoverageSummary: {
            gaps: doc.journalCoverageSummary?.gaps,
            range: doc.journalCoverageSummary?.range
         },
         lc_call_numbers: doc.lc_call_numbers,
         libguides: doc.libguides,
         library: doc.library,
         libraries: doc.libraries,
         link: doc.link,
         link_to_pdf: doc.link_to_pdf,
         proquest_doc_insights_link: doc.proquest_doc_insights_link,
         meeting_names: doc.meeting_names,
         page_count: doc.page_count,
         open_access_link: doc.open_access_link,
         open_url: doc.open_url,
         publication_date: doc.publication_date,
         publication_series_title: doc.publication_series_title,
         publication_title: doc.publication_title,
         publication_years: doc.publication_years,
         scopus_cited_references_url: doc.scopus_cited_references_url,
         scopus_references_count: doc.scopus_references_count,
         secondary_resource_type: doc.secondary_resource_type,
         simple_title: doc.simple_title,
         snippet: doc.snippet,
         summon_additional_links: doc.summon_additional_links,
         thumbnail_small: doc.thumbnail_small,
         volumes: doc.volumes,
         web_of_science: doc.web_of_science
      }
   }
}

SavedItemsService.$inject = ['storeService', 'availabilityService', '$cookies', 'configService', 'dialogService', '$rootScope', 'translationService', 'cloudStorageService', 'hooksService', 'alertService']

angular.module('summonApp.services')
   .service('savedItemsService', SavedItemsService)
